import PropTypes from "prop-types";
import { actionColumns } from "../../utils/columns";

const IssueProps = PropTypes.shape({
  assignee_display: PropTypes.string,
  assignee_name: PropTypes.string,
  bonfire_status: PropTypes.string,
  closed: PropTypes.any,
  components: PropTypes.string,
  context: PropTypes.string.isRequired,
  created: PropTypes.any,
  creator_name: PropTypes.string.isRequired,
  creator_name_display: PropTypes.string.isRequired,
  description: PropTypes.string,
  jira_link: PropTypes.string.isRequired,
  key: PropTypes.string.isRequired,
  priority: PropTypes.string.isRequired,
  project_key: PropTypes.string.isRequired,
  project_name: PropTypes.string.isRequired,
  reporter_name: PropTypes.string.isRequired,
  reporter_name_display: PropTypes.string.isRequired,
  resolution: PropTypes.string,
  resolutiondate: PropTypes.any,
  responsible: PropTypes.string.isRequired,
  screenshot_link: PropTypes.string,
  site_comments: PropTypes.any,
  skyspark_link: PropTypes.string,
  spark_type: PropTypes.string,
  status: PropTypes.string.isRequired,
  summary: PropTypes.string.isRequired,
  target: PropTypes.string,
  total_financial_impact: PropTypes.any,
  transition_reason: PropTypes.string,
  updated: PropTypes.any,
  operational_savings: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
  ]),
  elec: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  gas: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  water: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
});

const IssueDefaults = {
  assignee_name: "Unassigned",
  assignee_display: "Unassigned",
  closed: undefined,
  components: "Unknown",
  created: undefined,
  elec: 0,
  gas: 0,
  operational_savings: "",
  resolution: "",
  resolutiondate: undefined,
  screenshot_link: undefined,
  site_comments: undefined,
  skyspark_link: "",
  spark_type: "Unassigned",
  target: "",
  total_financial_impact: undefined,
  transition_reason: undefined,
  updated: undefined,
  water: 0,
};

const ActiveColumnsProps = PropTypes.shape({
  [actionColumns.ID.key]: PropTypes.bool,
  [actionColumns.PRIORITY.key]: PropTypes.bool,
  [actionColumns.SITE.key]: PropTypes.bool,
  [actionColumns.SUMMARY.key]: PropTypes.bool,
  [actionColumns.CONTEXT.key]: PropTypes.bool,
  [actionColumns.RESPONSIBLE.key]: PropTypes.bool,
  [actionColumns.DATES.key]: PropTypes.bool,
  [actionColumns.STATUS.key]: PropTypes.bool,
});

export { IssueProps, ActiveColumnsProps, IssueDefaults };
